import axios from 'axios'

export const all = (searchParams?: URLSearchParams) => axios.get('v1/catalogo/donors', {
  params: searchParams || undefined,
})

export const find = (id: string, options?: any) => {
  return axios.get(`v1/catalogo/donors/${id}`, options)
}

export const characteristics = () => axios.get('v1/catalogo/donors/characteristics')

export const create = (data: any) => axios.post('v1/catalogo/donors', data)

export const pdf = (id: string) => axios.get(`v1/catalogo/donors/${id}/pdf`, {
  responseType: 'blob',
})

export const favorite = (id: string) => axios.post(`v1/catalogo/donors/${id}/favorite`)

export const favorites = () => axios.get('v1/catalogo/donors/favorites')